import React from 'react'

import type { StatoForm } from '../actions'

// The prototype has no error colour: a dark red that keeps AA contrast on the cream background.
const rosso = '#a3261b'

/** Error under a single input. */
export const ErroreCampo: React.FC<{ messaggio?: string }> = ({ messaggio }) =>
  messaggio ? (
    <small role="alert" style={{ color: rosso, display: 'block', fontWeight: 400, marginTop: 5 }}>
      {messaggio}
    </small>
  ) : null

/** The form-level answer of a server action (`.accountfeedback`, as in the prototype). */
export const Esito: React.FC<{ stato: StatoForm }> = ({ stato }) => (
  <p
    className="accountfeedback"
    role={stato.stato === 'errore' ? 'alert' : 'status'}
    style={stato.stato === 'errore' ? { color: rosso } : undefined}
  >
    {stato.messaggio}
  </p>
)
